import React, { useEffect, useState } from "react";
import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from "@mui/material";
import { updateParentAndChildrenValues } from "../../utils/mergeRoleSchema";

export const CheckboxGroup = ({ data, handleChange, fieldName, setFieldValue, setFieldTouched, label,errors }) => {
    console.log("datadata", data)
    const [state, setState] = useState(data);
    const [selectAll, setSelectAll] = useState(false);
    const handleParentChange = (moduleIndex) => {
        const newState = [...state];
        const parentChecked = newState[moduleIndex].value !== true;

        // Set parent value and update all children
        newState[moduleIndex].value = parentChecked ? true : false;
        newState[moduleIndex].children = newState[moduleIndex].children.map((child) => ({
            ...child,
            value: parentChecked,
        }));
        handleChange(fieldName, newState, setFieldValue, setFieldTouched)
        setState(newState);
    };

    const handleChildChange = (moduleIndex, childIndex) => {
        const newState = [...state];
        const childChecked = !newState[moduleIndex].children[childIndex].value;

        // Update child value
        newState[moduleIndex].children[childIndex].value = childChecked;

        // Determine the parent state
        const allChecked = newState[moduleIndex].children.every((child) => child.value);
        const someChecked = newState[moduleIndex].children.some((child) => child.value);

        // Parent is `true` only if all children are selected
        newState[moduleIndex].value = allChecked ? true : someChecked ? true : false; // `null` for indeterminate state.
        handleChange(fieldName, newState, setFieldValue, setFieldTouched)
        setState(newState);
    };

    useEffect(() => { setState([...data]) }, [data])
    // useEffect(() => { handleChange(fieldName, state, setFieldValue, setFieldTouched) }, [state]);

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2, width: "100%" }}>
                <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold", color: errors?.[fieldName]?"error.main":"text.secondary" }} mt={0.8} >{label} *</Typography>
                <FormControlLabel
                    label={"Select All"}
                    control={<Checkbox
                        checked={selectAll}
                        onChange={(e) => {
                            setSelectAll(e.target.checked)
                            handleChange(fieldName, updateParentAndChildrenValues(state, e.target.checked), setFieldValue, setFieldTouched)
                        }}
                        sx={{
                            "& .MuiSvgIcon-root": { fontSize: 16 }, // Reduce child checkbox size
                        }}
                    />}
                    sx={{
                        "& .MuiFormControlLabel-label": {
                            fontSize: "14px", // Font size for the parent label
                            fontWeight: "bold", // Bold font for the parent
                            color: "#525459"
                        },
                        marginBottom: 0, // Remove extra spacing below parent checkbox
                    }}
                />
            </Box>
            <Grid container spacing={2} ml={0.5} mt={0}>
                {state.map((module, moduleIndex) => (
                    <Grid item xs={4} key={module.module}>
                        <FormGroup sx={{ marginBottom: 0.5, border: "1px solid #dadada", borderRadius: "10px", padding: "5px 8px" }}>
                            {/* Parent Checkbox */}
                            <FormControlLabel
                                label={module.name}
                                control={
                                    <Checkbox
                                        checked={module.value === true}
                                        indeterminate={module.children.some((child) => child.value) && !module.children.every((child) => child.value)}
                                        onChange={() => handleParentChange(moduleIndex)}
                                        sx={{
                                            "& .MuiSvgIcon-root": { fontSize: 18 }, // Reduce checkbox size
                                        }}
                                    />
                                }
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "14px", // Font size for the parent label
                                        fontWeight: "bold", // Bold font for the parent
                                    },
                                    marginBottom: 0, // Remove extra spacing below parent checkbox
                                }}
                            />
                            {/* Child Checkboxes */}
                            <div style={{
                                borderBottom: "1px solid #dadada",

                            }}></div>
                            {module.children.map((child, childIndex) => {
                                return (
                                    <FormControlLabel
                                        key={child.key}
                                        label={child.name}
                                        control={
                                            <Checkbox
                                                checked={child.value}
                                                onChange={() => handleChildChange(moduleIndex, childIndex)}
                                                sx={{
                                                    "& .MuiSvgIcon-root": { fontSize: 16 }, // Reduce child checkbox size
                                                }}
                                            />
                                        }
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                fontSize: "12px", // Font size for the child labels
                                            },
                                            marginLeft: 2, // Indent child checkboxes
                                            marginBottom: 0, // Remove extra spacing between children
                                        }}
                                    />
                                )
                            })}
                        </FormGroup>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

// Helper function to initialize the state
const initializeCheckedValues = (json) => {
    return json.map((module) => ({
        ...module,
        value: false, // Parent initially unchecked
        children: module.children.map((child) => ({
            ...child,
            value: false, // Children initially unchecked
        })),
    }));
};
